import { createFileRoute } from '@tanstack/react-router';
import { LayoutContent } from '../../features/shared/components/layout/LayoutContent';
import ReportExecutionErrorAlert from '../../features/data-exports/components/alerts/ReportExecutionErrorAlert';
import RunningOnBehalfOfStudentAlert from '../../features/data-exports/components/alerts/RunningOnBehalfOfStudentAlert';
import DataSourceContainer from '../../features/data-exports/components/data-sources/DataSourceContainer';
import RunDataExportsBtn from '../../features/data-exports/components/buttons/RunDataExportsBtn';
import DownloadFileModal from '../../features/data-exports/modals/DownloadFileModal';
import { Placeholder } from 'react-bootstrap';
import { number, string, object as zodObject } from 'zod';
import ErrorAlert from '../../features/data-exports/components/alerts/ErrorAlert';
import PreviewListItemModal from '../../features/data-exports/components/list-items/modals/PreviewListItemModal';
import { useDataExports } from '../../features/data-exports/hooks/use-data-exports.hook';
import { ApiConfigurationGuard } from '../../features/api-configuration/components/ApiConfigurationGuard';
import { AuthenticationGuard } from '../../features/authentication/AuthenticationGuard';
import DataExportsPageTitle from '../../features/data-exports/components/page-title/DataExportsPageTitle';

const dataExportsSearchSchema = zodObject({
    page: number().optional().catch(1),
    groupBy: string().optional(),
    from: string().optional(),
    until: string().optional(),
    jobSeekerId: number().optional(),
    dataSourceId: number().optional(),
});

export const Route = createFileRoute('/data-exports/$dataExportsId')({
    component: () => <DataExportsPageComponent />,
    params: {
        parse: params => ({
            dataExportsId: parseInt(params.dataExportsId, 10),
        }),
        stringify: value => ({ dataExportsId: value.dataExportsId.toString() }),
    },
    validateSearch: search => dataExportsSearchSchema.parse(search),
});

function DataExportsPageComponent() {
    const { data, isLoading: loadingData, error } = useDataExports();

    return (
        <AuthenticationGuard>
            <ApiConfigurationGuard>
                <LayoutContent className='pt-4 mb-4 bg-primary-light'>
                    <LayoutContent.Padding className='pb-2'>
                        <DataExportsPageTitle />
                    </LayoutContent.Padding>
                </LayoutContent>
                {!error
                    ? (
                        <>
                            <LayoutContent className='container-lg'>
                                <h2>
                                    {loadingData
                                        ? (
                                            <Placeholder as='div' animation='wave'>
                                                <Placeholder xs={6} />
                                            </Placeholder>
                                        )
                                        : data?.data.name}
                                </h2>
                                <div className='mb-4'>
                                    {loadingData
                                        ? (
                                            <Placeholder as='div' animation='wave'>
                                                <Placeholder xs={12} />
                                            </Placeholder>
                                        )
                                        : data?.data.description}
                                </div>
                                <ReportExecutionErrorAlert />
                                <RunningOnBehalfOfStudentAlert />
                                <div className='mb-2'>
                                    <DataSourceContainer />
                                </div>
                                <RunDataExportsBtn />
                            </LayoutContent>
                            <DownloadFileModal />
                            <PreviewListItemModal />
                        </>
                    )
                    : <ErrorAlert error={error} />}
            </ApiConfigurationGuard>
        </AuthenticationGuard>
    )
}
